import { createDate } from '@unistocks/shared/utils/util';
import type { DateStringValue } from '../../types';

/**
 * ISO week number of the week containing the given 7 dates, derived from its
 * Monday. Mirrors @mantine/dates `getWeekNumber`.
 */
export function getWeekNumber(week: DateStringValue[]): number {
  const monday = week.find(date => createDate(date).weekday === 1)!;
  return createDate(monday).weekNumber;
}
